<template>
    <transition name="fade">
        <div class="login" v-show="$store.getters.showLogin" @click.self="closeLogin">
            <i-app v-show="showIapp" @close="showIapp = false"></i-app>
            <wx-panel :visiable.sync="showWx"></wx-panel>
            <div class="login-container" v-show="!showIapp && !showWx">
                <div class="container-left">
                    <div class="bg-img">
                        <img
                            v-if="$local.get('lang') !== 'zh-CN'"
                            src="../../assets/images/ebbly-login.png"
                            alt
                        />
                        <img v-else src="../../assets/images/ebbly-login-cn.png" alt />
                    </div>
                </div>
                <div class="container-right">
                    <div class="form">
                        <p class="form-header">
                            <i class="iconfont icon-cancel" @click="closeLogin"></i>
                        </p>
                        <h4 class="login-title">{{$t('signin')}}</h4>
                        <div class="form-container" @keydown="enter">
                            <el-tabs :stretch="true" v-model="loginType" @tab-click="tabClick">
                                <el-tab-pane :label="$t('email')" name="1">
                                    <el-form
                                        :model="emailForm"
                                        :rules="emailRule"
                                        ref="emailForm"
                                        style="margin-top:20px;"
                                    >
                                        <el-form-item prop="email">
                                            <el-input
                                                v-model.trim="emailForm.email"
                                                :placeholder="$t('email')"
                                            ></el-input>
                                        </el-form-item>
                                        <input type="text" style="display:none;" />
                                        <input type="password" style="display:none;" />
                                        <el-form-item prop="passwd">
                                            <el-input
                                                v-model.trim="emailForm.passwd"
                                                :placeholder="$t('login_password_as')"
                                                :type="emailForm.type"
                                            >
                                                <i
                                                    class="iconfont show-pass-icon"
                                                    :class="[emailForm.type === 'password' ? 'icon-icon_visiblex' : 'icon-icon_invisiblex']"
                                                    slot="suffix"
                                                    @click="toggleShowPasswd(emailForm)"
                                                ></i>
                                            </el-input>
                                        </el-form-item>
                                        <p class="forget-p">
                                            <span @click="forgetPasswd">{{$t('forget_passwd_ask')}}</span>
                                        </p>
                                    </el-form>
                                </el-tab-pane>
                                <!-- mobile -->
                                <el-tab-pane :label="$t('mobile_text')" name="2">
                                    <el-form
                                        :model="phoneForm"
                                        :rules="phoneRule"
                                        ref="phoneForm"
                                        style="margin-top:20px;"
                                    >
                                        <el-form-item prop="phone">
                                            <el-input
                                                v-model.trim="phoneForm.phone"
                                                :placeholder="$t('mobile_text')"
                                            >
                                                <el-select
                                                    v-model="phoneForm.code"
                                                    placeholder="code"
                                                    slot="prepend"
                                                    class="input-with-select"
                                                    filterable
                                                >
                                                    <el-option
                                                        v-for="item in $store.getters.countryList"
                                                        :key="item.country_id"
                                                        :label="'+' + item.code"
                                                        :value="'+' + item.code"
                                                    >
                                                        <span
                                                            style="float: left;color: #484848;"
                                                        >{{item.name}}</span>
                                                        <span
                                                            style="float: right;color: #767676;"
                                                        >{{`+${item.code}`}}</span>
                                                    </el-option>
                                                </el-select>
                                            </el-input>
                                        </el-form-item>
                                        <el-form-item prop="passwd">
                                            <el-input
                                                v-model.trim="phoneForm.passwd"
                                                :placeholder="$t('login_password_as')"
                                                :type="phoneForm.type"
                                            >
                                                <i
                                                    class="iconfont show-pass-icon"
                                                    :class="[phoneForm.type === 'password' ? 'icon-icon_visiblex' : 'icon-icon_invisiblex']"
                                                    slot="suffix"
                                                    @click="toggleShowPasswd(phoneForm)"
                                                ></i>
                                            </el-input>
                                        </el-form-item>
                                        <p class="forget-p">
                                            <span @click="forgetPasswd">{{$t('forget_passwd_ask')}}</span>
                                        </p>
                                    </el-form>
                                </el-tab-pane>
                            </el-tabs>
                            <button class="login-btn" @click="loginValidate">{{$t('signin')}}</button>
                        </div>
                        <!-- 第三方登录 -->
                        <div class="other-login">
                            <div class="line-text">{{$t('third_login')}}</div>
                            <div class="login-logo">
                                <img
                                    src="../../assets/logo/logo_iapp@2x.png"
                                    alt
                                    @click="loginByIApp"
                                />
                                <span>iAPP</span>
                            </div>
                            <div class="login-logo">
                                <img
                                    src="../../assets/logo/logo_facebook@2x.png"
                                    alt
                                    @click="checkLoginState"
                                />
                                <span>Facebook</span>
                            </div>
                            <!-- <div class="login-logo">
                                <img src="../../assets/logo/logo_wechat@2x.png" alt="" @click="showWx = true">
                                <span>Wechat</span>
                            </div>-->
                        </div>
                    </div>
                    <p class="footer-tips">
                        <span>{{$t('ebbly_account')}}</span>
                        <span class="btn-text" @click="showSignup">{{$t('create_account')}}</span>
                    </p>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import IApp from "@/iapp/Index";
import WxPanel from "./components/WxPanel";
import { signinGtag, thirdPartyLoginGtag } from "@/lib/gtag.js";

export default {
    name: "login",
    components: {
        IApp,
        WxPanel
    },
    data() {
        return {
            loginType: "1", //1为邮箱，2为手机
            showIapp: false,
            showWx: false,
            avatar: require("../../assets/avatar/default_avartar_boy@2x.png"),
            emailForm: {
                email: "",
                passwd: "",
                type: "password"
            },
            emailRule: {
                email: [
                    {
                        required: true,
                        message: this.$t("email_error"),
                        trigger: "none"
                    },
                    {
                        type: "email",
                        message: this.$t("email_error"),
                        trigger: "none"
                    }
                ],
                passwd: [
                    {
                        required: true,
                        message: this.$t("reinput_passwd"),
                        trigger: "none"
                    }
                ]
            },
            phoneForm: {
                phone: "",
                passwd: "",
                type: "password",
                code: `+${this.$store.getters.country.code || 86}`
            },
            phoneRule: {
                phone: [
                    {
                        required: true,
                        message: this.$t("mobile_error"),
                        trigger: "none"
                    }
                ],
                passwd: [
                    {
                        required: true,
                        message: this.$t("reinput_passwd"),
                        trigger: "none"
                    }
                ]
            }
        };
    },
    methods: {
        enter(e) {
            if (e.keyCode === 13) {
                this.loginValidate();
            }
        },
        tabClick(ref) {
            // ref.$children[0].resetFields();
        },
        closeLogin() {
            this.$store.dispatch("toggleShowLogin", false);
            this.showIapp = false;
            this.$refs["emailForm"].resetFields();
            this.$refs["phoneForm"].resetFields();
        },
        toggleShowPasswd(form) {
            if (form.type === "password") {
                form.type = "text";
            } else {
                form.type = "password";
            }
        },
        loginByIApp() {
            this.showIapp = true;
        },
        checkLoginState() {
            let me = this;
            //防止浏览器拦截弹窗
            FB.login(
                function(response) {
                    // handle the response
                    if (response.status === "connected") {
                        // Logged into your app and Facebook.
                        me.getFBInfo();
                    }
                },
                { scope: "public_profile,email" }
            );
        },
        getFBInfo() {
            let me = this;
            FB.api("/me", function(response) {
                me.openLogin(response, 3);
            });
        },
        openLogin(info, type) {
            this.$req
                .post("webopenlogin", {
                    type_id: type,
                    openid: info.id,
                    avatar: info.headimgurl || "",
                    nikename: info.name || info.nickname || ""
                })
                .then(({ data }) => {
                    //埋点
                    thirdPartyLoginGtag({
                        登录类型: "facebook",
                        账户名称: info.name,
                        用户ID: data.data.user_id || ""
                    });
                    if (data.code === "2000") {
                        data.data.user_info.nickname = info.name;
                        this.$store.dispatch("updateToken", data.data.token);
                        this.$store.dispatch("updateUser", data.data);
                        this.$store.dispatch("updateAvatar", this.avatar);
                        this.$store.dispatch("toggleShowLogin", false);
                    }
                });
        },
        loginValidate() {
            if (this.loginType == 1) {
                /* 邮箱 */
                this.$refs["emailForm"].validate(valid => {
                    if (!valid) {
                        // this.$msg('请检查您的表单')
                        return;
                    }
                    this.login("email");
                });
            } else {
                /* 手机 */
                this.$refs["phoneForm"].validate(valid => {
                    if (!valid) {
                        // this.$msg('请检查您的表单')
                        return;
                    }
                    this.login("phone");
                });
            }
        },
        login(type) {
            let data = this[`${type}Form`];
            this.$req
                .post("login", {
                    login_type: this.loginType,
                    area_code: data.code,
                    account: data[type],
                    password: data.passwd
                })
                .then(resp => {
                    let userinfo = resp.data.data
                        ? resp.data.data.user_info
                        : {};
                    //埋点
                    signinGtag({
                        姓名: userinfo.first_name + "/" + userinfo.last_name,
                        "邮箱/手机": data[type],
                        用户ID: resp.data.data.user_id || ""
                    });
                    if (resp.data.code === "2000") {
                        /* 清空状态 */
                        this.$refs["emailForm"].resetFields();
                        this.$refs["phoneForm"].resetFields();

                        this.$store.dispatch(
                            "updateToken",
                            resp.data.data.token
                        );
                        this.$store.dispatch("updateUser", resp.data.data);
                        this.$store.dispatch(
                            "updateAvatar",
                            resp.data.data.user_info.extend.avatar
                        );
                        this.$store.dispatch("toggleShowLogin", false);
                    } else {
                        this.$msg.error(resp.data.msg);
                    }
                });
        },
        forgetPasswd() {
            if (this.loginType == 1) {
                this.$store.dispatch("updateForgetFlow", {
                    show: true,
                    type: "email"
                });
            } else {
                this.$store.dispatch("updateForgetFlow", {
                    show: true,
                    type: "mobile"
                });
            }
        },
        showSignup() {
            this.$store.dispatch("toggleShowSignup", true);
        }
    }
};
</script>

<style lang="scss" scoped>
@media screen and (max-width: 1367px) {
    .login {
        .login-container {
            width: 750px;
            height: 570px;
        }

        .login-btn {
            margin: 30px 0;
        }

        .container-right {
            .form-header {
                margin-bottom: 10px;
            }
        }

        .other-login .login-logo img {
            width: 40px;
            height: 40px;
        }

        .container-left {
            .bg-img,
            .container-left-inner {
                height: 570px;
            }
            .bg-img {
                width: 110%;
            }
            .bg-img img {
                width: 100%;
            }
            .logo-img {
                margin: 54px auto 25px;
            }
        }
    }
}
.login /deep/ .el-select .el-input {
    width: 100px;
}
.input-with-select {
    /deep/ .el-input-group__prepend {
        background-color: #fff;
    }
}
.login {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99;
    width: 100%;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(55, 55, 55, 0.6);
}
.login-container {
    width: 800px;
    height: 600px;
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    border-radius: 4px;
    box-shadow: 0px 6px 20px rgba(0, 0, 0, 0.19),
        0px 8px 17px rgba(0, 0, 0, 0.2);
    color: #484848;

    .container-left,
    .container-right {
        flex: 1;
        box-sizing: border-box;
    }
}

.container-left {
    position: relative;
    background-color: #c4c4c4;

    .bg-img {
        position: absolute;
        height: 600px;
        img {
            height: 100%;
        }
    }

    .container-left-inner {
        position: absolute;
        height: 600px;
        width: 100%;
        z-index: 2;
    }

    .logo-img {
        width: 80px;
        height: 46px;
        margin: 54px auto 47px;

        img {
            width: 100%;
            height: 100%;
        }
    }
    .logo-title {
        font-size: 16px;
        width: 294px;
        margin: 0 auto;
        text-align: center;
        color: #083d43;
    }
}
.container-right {
    display: flex;
    flex-direction: column;
    background-color: #fff;
    .login-title {
        font-size: 24px;
        margin: 16px 0;
        text-align: center;
    }
    .form {
        flex: 1;
        padding: 22px 24px 0;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }
    .form-container {
        flex: 1;
        box-sizing: border-box;
        padding: 0 21px;
    }
    .form-header {
        text-align: right;
        margin-bottom: 10px;
        i {
            cursor: pointer;
        }
    }
    .footer-tips {
        height: 44px;
        background-color: #efedec;
        text-align: center;

        span {
            font-size: 12px;
            line-height: 44px;
        }

        .btn-text {
            margin-left: 17px;
            font-size: 14px;
            color: #00a9ba;
            cursor: pointer;
        }
    }
}
.login-btn {
    border: none;
    width: 100%;
    height: 40px;
    background: linear-gradient(90deg, #52d6ce 0%, #00a9ba 100%);
    border-radius: 45px;
    margin: 52px 0;
    color: #fff;
    font-size: 14px;
    cursor: pointer;
}
.forget-p {
    text-align: right;
    font-size: 12px;
    margin-top: -10px;
    span {
        color: #767676;
        cursor: pointer;
        &:hover {
            color: #00a9ba;
        }
    }
}
.other-login {
    height: 100px;
    position: relative;
    border-top: 1px solid #eee;
    display: flex;
    justify-content: space-around;
    align-items: center;

    .login-logo {
        display: flex;
        align-items: center;
        flex-direction: column;
        flex: 1;
        text-align: center;
        img {
            width: 50px;
            height: 50px;
            cursor: pointer;
        }
        span {
            margin: 8px 0;
            color: #767676;
            font-size: 14px;
        }
    }

    .line-text {
        box-sizing: border-box;
        position: absolute;
        padding: 0 24px;
        top: 0;
        left: 50%;
        font-size: 14px;
        background-color: #fff;
        transform: translate(-50%, -50%);
    }
}
.show-pass-icon {
    font-size: 20px;
    padding-right: 5px;
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/Public/Login.vue